import { render } from "./addGroup.vue?vue&type=template&id=3ed5678a&scoped=true"
import script from "./addGroup.vue?vue&type=script&lang=js"
export * from "./addGroup.vue?vue&type=script&lang=js"

import "./addGroup.vue?vue&type=style&index=0&id=3ed5678a&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed5678a"]])

export default __exports__